module.exports = __webpack_public_path__ + "img/ibms.053ff3ce.png";